export const CONTACT_CREATE_REQUEST = "CONTACT_CREATE_REQUEST";
export const CONTACT_CREATE_SUCCESS = "CONTACT_CREATE_SUCCESS";
export const CONTACT_CREATE_FAIL = "CONTACT_CREATE_FAIL";
export const CONTACT_CREATE_RESET = "CONTACT_CREATE_RESET";

export const CONTACT_DETAILS_REQUEST = "CONTACT_DETAILS_REQUEST";
export const CONTACT_DETAILS_SUCCESS = "CONTACT_DETAILS_SUCCESS";
export const CONTACT_DETAILS_FAIL = "CONTACT_DETAILS_FAIL";
export const CONTACT_DETAILS_RESET = "CONTACT_DETAILS_RESET";

export const CONTACT_CREATE_REQUEST2 = "CONTACT_CREATE_REQUEST2";
export const CONTACT_CREATE_SUCCESS2 = "CONTACT_CREATE_SUCCESS2";
export const CONTACT_CREATE_FAIL2 = "CONTACT_CREATE_FAIL2";
export const CONTACT_CREATE_RESET2 = "CONTACT_CREATE_RESET2";

export const CONTACT_LIST_REQUEST = "CONTACT_LIST_REQUEST";
export const CONTACT_LIST_SUCCESS = "CONTACT_LIST_SUCCESS";
export const CONTACT_LIST_FAIL = "CONTACT_LIST_FAIL";
export const CONTACT_LIST_RESET = "CONTACT_LIST_RESET";

